<template>
  <div>
    <header class="header">
      <div class="wrapper">
        <a href="" class="logo">
          <img src="images/logo.svg" alt="pic">
        </a>
      </div>
    </header>

    <section class="s1">
      <div class="s1-bg">
        <div class="s1-bg--img"></div>
        <img src="images/sprites/1.svg" alt="pic" class="s1-bg--img-1">
        <img src="images/sprites/2.svg" alt="pic" class="s1-bg--img-2">
        <img src="images/sprites/3.svg" alt="pic" class="s1-bg--img-3">
        <img src="images/sprites/4.svg" alt="pic" class="s1-bg--img-4">
        <img src="images/sprites/5.svg" alt="pic" class="s1-bg--img-5">
        <img src="images/sprites/6.svg" alt="pic" class="s1-bg--img-6">
        <img src="images/sprites/7.svg" alt="pic" class="s1-bg--img-7">
        <img src="images/sprites/8.svg" alt="pic" class="s1-bg--img-8">
        <img src="images/sprites/9.svg" alt="pic" class="s1-bg--img-9">
        <img src="images/sprites/zaika.svg" alt="pic" class="s1-bg--img-10">
      </div>
      <div class="wrapper">
        <div class="z-container">
          <h1 class="heading">
            Волшебный мир салатов для Зайчат
          </h1>
          <p class="text">
            Наша миссия в данном проекте
            –
            с помощью
            самых любимых героев обратить внимание детей
            на свежие салаты, помогая родителям наполнить
            рацион пользой овощей.
          </p>
          <a href="https://www.bdsalads.ru" target="_blank" class="link">
            Перейти на сайт
          </a>
          <button class="show-video" @click="openPopup">
            <z-icon type="play"></z-icon>
            Посмотреть видео
          </button>
        </div>
      </div>
      <button class="scroll-btn" @click="scrollTo('.s2')">
        <z-icon type="scroll"></z-icon>
      </button>
    </section>

    <section class="s2">
      <div class="wrapper">
        <div class="blocks">
          <div class="rain"
               :class="{active: isRain}"
               :style="{backgroundImage: 'url(..images/'+ rainType +'.svg)'}"
          ></div>

          <div class="img-block sticky">
            <div class="img-block--inner">
              <img
                  src="images/lesorub.png"
                  alt="pic"
                  :style="{
                    opacity: opacityAnimation1,
                    transform: 'scale('+ (opacityAnimation3) +') translateY('+ opacityAnimation4 +'px) rotate(-'+ opacityAnimation7 +'deg)',
                  }"
              >
            </div>
            <div class="img-block--inner">
              <img src="images/pocket.png" alt="pic" :style="{opacity: opacityAnimation2}">
            </div>
          </div>
          <div class="text-blocks">
            <div class="text-block">
              <h3 class="text-block--title">
                Подарок внутри
              </h3>
              <p class="text-block--text">
                Салат
                c
                подарком внутри
                –
                коллекционная
                игрушка
                Зая, 3 разных вида.
              </p>
            </div>
            <div class="text-block sticky" data-animate-vegetables :class="{animate: isAnimation}">
              <h3 class="text-block--title">
                Идеальная порция
              </h3>
              <p class="text-block--text">
                В
                миксах
                серии
                –
                сбалансированные под вкусовые
                предпочтения детей яркие салаты и овощи, в объеме
                одной порции весом 70 г.
              </p>
            </div>
            <div class="text-block sticky">
              <div @click="startRain('romano')">
                <z-icon
                    type="romano"
                    class="text-block--img-3"
                    :class="{disable: isRain}"
                    :style="{
                    opacity: opacityAnimation6
                  }"
                ></z-icon>
              </div>
              <div @click="startRain('cabbage')">
                <z-icon
                    type="cabbage"
                    class="text-block--img-1"
                    :class="{disable: isRain}"
                    :style="{
                      opacity: opacityAnimation6
                    }"
                ></z-icon>
              </div>
              <div @click="startRain('carrot')">
                <z-icon
                    type="carrot"
                    class="text-block--img-2"
                    :class="{disable: isRain}"
                    :style="{
                      opacity: opacityAnimation6
                    }"
                ></z-icon>
              </div>

            </div>
            <div class="text-block" data-scroll-anchor>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="s3">
      <div class="items">
        <div class="item">
          <div class="item--inner">
            <h3 class="item--title">
              Самый витаминный микс
            </h3>
            <ul class="item--list">
              <li class="item--list-item">
                <z-icon type="pic1"></z-icon>
                Сочный айсберг – источник множества
                витаминов В, А и Е.
              </li>
              <li class="item--list-item">
                <z-icon type="pic3"></z-icon>
                В зеленом
                романо –
                много магния,
                железа, калия, кальция и витаминов
                А и С.
              </li>
              <li class="item--list-item">
                <z-icon type="pic2"></z-icon>
                Морковка
                –
                богата витаминами А, Е,
                клетчаткой,
                глюкозой и сладкой
                фруктозой.
              </li>
            </ul>
          </div>
        </div>
        <div class="item">
          <div class="item--inner">
            <img src="images/1.png" alt="pic" class="item--pic">
            <div class="item--bg-1">
              <img src="images/floor-1-1.svg" alt="pic" class="item--bg-1-1">
              <img src="images/leaf-1-1.svg" alt="pic" class="item--bg-1-2">
              <img src="images/leaf-1-2.svg" alt="pic" class="item--bg-1-3">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item--inner">
            <img src="images/2.png" alt="pic" class="item--pic">
            <div class="item--bg-2">
              <img src="images/floor-2-1.svg" alt="pic" class="item--bg-2-1">
              <img src="images/leaf-2-1.svg" alt="pic" class="item--bg-2-2">
              <img src="images/leaf-2-2.svg" alt="pic" class="item--bg-2-3">
              <img src="images/leaf-2-3.svg" alt="pic" class="item--bg-2-4">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item--inner">
            <h3 class="item--title">
              Микс – источник здоровья
            </h3>
            <ul class="item--list">
              <li class="item--list-item">
                <z-icon type="pic1"></z-icon>
                Хрустящий асберг
                –
                полон
                витаминов
                и укрепляет иммунитет.

              </li>
              <li class="item--list-item">
                <z-icon type="pic3"></z-icon>
                Свежий
                романо
                –
                насыщен
                полезными микроэлементами:
                калием,
                железом и магнием.

              </li>
              <li class="item--list-item">
                <z-icon type="pic4"></z-icon>
                Сладкий перчик
                –
                богат железом
                и
                фосфором для поддержания
                здоровья
                .
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="s4">
      <div class="wrapper">
        <h2 class="title">
          Собери свою компанию зай!
        </h2>

        <div class="items">
          <div class="item">
            <img src="images/smen.png" alt="pic">
          </div>
          <div class="item">
            <img src="images/lesorub.png" alt="pic">
          </div>
          <div class="item">
            <img src="images/girl.png" alt="pic">
          </div>
        </div>
      </div>
    </section>

    <section class="s5">
      <p class="subtitle">
        СОЦИАЛЬНЫЕ СЕТИ
      </p>
      <div class="z-container">
        <h2 class="title">
          Следуйте за нами
          и готовьте со вкусом!
        </h2>
        <div class="items">
          <a href="" class="item" style="background-image: url('images/youtube.jpeg')">
            <div class="item--link">
              <z-icon type="youtube"></z-icon>
              <p>
                следить за&nbsp;нашими<br>
                рецептами
              </p>
            </div>
          </a>
          <a href="" class="item" style="background-image: url('images/inst.jpeg')">
            <div class="item--link">
              <z-icon type="inst"></z-icon>
              <p>
                следить за&nbsp;нашими<br>
                рецептами
              </p>
            </div>
          </a>
          <a href="" class="item" style="background-image: url('images/vk.jpeg')">
            <div class="item--link">
              <z-icon type="facebook"></z-icon>
              <p>
                следить за&nbsp;нашими<br>
                рецептами
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="z-container-fluid">
        <div class="z-container">
          <div class="block">
            <a href="" class="logo">
              <img src="images/logo.svg" alt="pic">
            </a>
            <p class="text">
              Завод в г. Котельники,<br>
              Московская область<br>
              АО «Белая Дача Трейдинг»<br>
              <br>
              140053 Московская область,<br>
              г. Котельники, Яничкин пр., д. 4
            </p>
            <a href="https://www.bdsalads.ru/jobs/" class="btn">
              Вакансии
            </a>
            <p class="copyright">
              Copyright © 2020 «Белая Дача». Все права защищены. При использовании материалов ссылка обязательна.
            </p>
          </div>

          <div class="block-big">
            <div class="block-inner">
              <div class="col hidden-md">
                <p class="footer--title">
                  Навигация
                </p>
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/salads/">Салаты</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/recipes/">Рецепты</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/horeca/">Партнёры </a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/about_work/">Как мы&nbsp;работаем</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/about_work/#freshness_patrol">Патруль Свежести</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/about/">О&nbsp;компании</a>
                  </li>
                </ul>
              </div>
              <div class="col hidden-md">
                <p class="footer--title">
                  Следите за нами
                </p>
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="https://www.facebook.com/bdsalads/" target="_blank">Facebook</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.instagram.com/bdsalads" target="_blank">Instagram</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.youtube.com/user/Belayadacha" target="_blank">Youtube</a>
                  </li>
                  <li class="footer--item">
                    <a href="https://vk.com/bdsalads" target="_blank">Vkontakte</a>
                  </li>
                </ul>
              </div>
              <div class="col">
                <p class="footer--title">
                  Связаться с нами
                </p>
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="tel:+7 495 921 1747">Тел.: +7 495 921 1747</a>
                  </li>
                  <li class="footer--item">
                    <a href="tel:+7 495 921 1749">Факс: +7 495 921 1749</a>
                  </li>
                  <li class="footer--item">
                    <a href="mailto:info@bdsalads.ru">nfo@bdsalads.ru</a>
                  </li>
                </ul>
              </div>
              <div class="col hidden-md">
                <p class="footer--title">
                  Контакты в регионах
                </p>
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/contact/#novosibirsk">
                      Белая Дача<br>
                      Новосибирск ↗︎
                    </a>
                  </li>
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/contact/#alabuga">
                      Белая Дача<br>
                      Алабуга ↗︎
                    </a>
                  </li>
                </ul>
              </div>

              <div class="col mt">
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/privacy-policy/">
                      Политика<br>конфиденциальности  ↗︎
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col mt">
                <ul class="footer--list">
                  <li class="footer--item">
                    <a href="https://www.bdsalads.ru/policy/">
                      Политика в&nbsp;области<br>охраны труда  ↗︎
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-big mt">
                <p class="footer-quote">
                  *по данным независимого исследовательского холдинга «Ромир», Белая Дача — бренд № 1 в категории
                  готовых к употреблению салатов; данные за период 2013-2019 гг.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <transition name="z-popup">
      <div class="z-popup" v-if="isPopup">
        <div class="z-popup--layout" @click="closePopup"></div>
        <div class="z-popup--body">
          <video id="video" preload="auto" autoplay="true" muted="muted" @pause="videoEnd">
            <source src="/media/video-bg.mp4">
          </video>
          <button class="video-close" @click="closePopup">
            <z-icon
                type="line"
            ></z-icon>
          </button>
          <button class="video-volume" @click="triggerVolume">
            <z-icon
                type="mute"
                v-show="!isMuted"
            ></z-icon>
            <z-icon
                type="sound"
                v-show="isMuted"
            ></z-icon>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Home',

  data(){
    return {
      isMuted: true,
      rainType: false,
      isRain: false,
      isPopup: false,
      isAnimation: false,
      opacityAnimation1: 1,
      opacityAnimation2: 1,
      opacityAnimation3: 1,
      opacityAnimation4: 1,
      opacityAnimation5: false,
      opacityAnimation6: 1,
      opacityAnimation7: 1
    }
  },
  mounted: function (){
    let self = this;
    window.addEventListener('scroll', function (e){
      let windowHeight = window.innerHeight
      let startAnimationCoords = document.querySelector('[data-scroll-anchor]').getBoundingClientRect()
      let startVegetablesAnimationCoords = document.querySelector('[data-animate-vegetables]').getBoundingClientRect()
      let startAnimationOffset = windowHeight - startAnimationCoords.y
      let startAnimationVegetablesOffset = windowHeight - startVegetablesAnimationCoords.y


      if(
          startAnimationVegetablesOffset>windowHeight/1.2
          && startVegetablesAnimationCoords.y + startVegetablesAnimationCoords.height > windowHeight/2
      ){
        self.opacityAnimation5 = true
        self.isAnimation = true
      }
      else{
        self.opacityAnimation5 = false
        self.isAnimation = false
      }

      if(startAnimationOffset>0 && startAnimationCoords.y + startAnimationCoords.height > 0){
        self.opacityAnimation1 = 1 - (Math.round(100/windowHeight*startAnimationOffset))/100
        self.opacityAnimation3 = 1 - ((Math.round(100/windowHeight*startAnimationOffset))/100)/4
        self.opacityAnimation4 = ((Math.round(100/windowHeight*startAnimationOffset))/100)*100
        self.opacityAnimation2 = (Math.round(100/windowHeight*startAnimationOffset))/100
        self.opacityAnimation6 = 1 - (Math.round(100/windowHeight*startAnimationOffset))/50
        self.opacityAnimation7 = (Math.round(100/windowHeight*startAnimationOffset))/4
      }
      else{

      }
    })

    //self.openPopup();
  },
  methods: {
    openPopup: function (){
      this.isPopup = true
    },
    closePopup: function (){
      this.isPopup = false
    },
    videoEnd: function (e){
      this.closePopup()
    },
    startRain: function (type){
      let self = this
      self.isRain = true
      self.rainType = type

      setTimeout(function (){
        self.isRain = false
      }, 3000)
    },
    scrollTo: function (id){
      console.log(id)
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    triggerVolume: function (){
      this.isMuted = !this.isMuted;
      let video = document.getElementById('video')
      video.muted = this.isMuted;
    }
  }
}
</script>

<style scoped>

</style>